import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import LandingPageSandbox from "./components/LandingPageSandbox";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import SampleRequestPage from "./pages/SampleRequestPage";
import TrialRequestPage from "./pages/TrialRequestPage";
import OrderNowPage from "./pages/OrderNowPage";
import BlogPage from "./pages/BlogPage";
import FAQPage from "./pages/FAQPage";
import ProductOverviewPage from "./pages/ProductOverviewPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import SpecificationsPage from "./pages/SpecificationsPage";
// VideosPage removed - videos now live on Resource Library page
import ResourceLibrarySandboxPage from "./pages/ResourceLibrarySandboxPage";
import SupportPage from "./pages/SupportPage";
import CareersPage from "./pages/CareersPage";
import PartnersPage from "./pages/PartnersPage";
import FindDistributorPage from "./pages/FindDistributorPage";
import SiteMapPage from "./pages/SiteMapPage";
import PrivacyPolicySandboxPage from "./pages/PrivacyPolicySandboxPage";
import TermsOfServiceSandboxPage from "./pages/TermsOfServiceSandboxPage";
// import RefundPolicyPage from "./pages/RefundPolicyPage"; // Hidden for now
import IntellectualPropertyPage from "./pages/IntellectualPropertyPage";
import IFUPage from "./pages/IFUPage";
import { CartProvider } from "./contexts/CartContext";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/toaster";
import DistributorsPage from "./pages/DistributorsPage";
import DistributorApplyPage from "./pages/DistributorApplyPage";
import DistributorLoginPage from "./pages/DistributorLoginPage";
import DistributorPortalPage from "./pages/DistributorPortalPage";
import DistributorAdminPage from "./pages/DistributorAdminPage";

function ScrollToHash() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
  }, [hash]);
  return null;
}

function App() {
  return (
    <AuthProvider>
    <CartProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToHash />
          <Routes>
            <Route path="/" element={<LandingPageSandbox />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/sample-request" element={<SampleRequestPage />} />
            <Route path="/trial-request" element={<TrialRequestPage />} />
            <Route path="/order-now" element={<OrderNowPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/product-overview" element={<ProductOverviewPage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/specifications" element={<SpecificationsPage />} />
            {/* Videos page removed - redirect to resource library */}
            <Route path="/videos" element={<Navigate to="/resource-library" replace />} />
            <Route path="/resource-library" element={<ResourceLibrarySandboxPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/partners" element={<PartnersPage />} />
            <Route path="/find-distributor" element={<FindDistributorPage />} />
            <Route path="/site-map" element={<SiteMapPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicySandboxPage />} />
            <Route path="/terms-of-service" element={<TermsOfServiceSandboxPage />} />
            {/* <Route path="/refund-policy" element={<RefundPolicyPage />} /> */}
            <Route path="/ip" element={<IntellectualPropertyPage />} />
            <Route path="/ifu" element={<IFUPage />} />
            {/* Distributor Portal */}
            <Route path="/distributors" element={<DistributorsPage />} />
            <Route path="/distributors/apply" element={<DistributorApplyPage />} />
            <Route path="/distributors/login" element={<DistributorLoginPage />} />
            <Route path="/distributors/reset-password" element={<DistributorLoginPage />} />
            <Route path="/distributors/portal" element={<DistributorPortalPage />} />
            <Route path="/distributors/admin" element={<DistributorAdminPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </CartProvider>
    </AuthProvider>
  );
}

export default App;